module.exports = __webpack_public_path__ + "media/images/icons/arrow_down-f7ec76597e436eba5c8f9aa82194d43e.svg";